"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getEventTargetByTagName;
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getEventTargetByTagName(evt, tag) {
  if ((0, _get["default"])(evt, 'currentTarget.tagName') === tag) {
    return evt.currentTarget;
  }
  if ((0, _get["default"])(evt, 'target.tagName') === tag) {
    return evt.target;
  }
  return null;
}